import React, { useId } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Modal, Textarea } from '@/components/ds-zta';

interface DenyAccessRequestModalProps {
  requestedBy: string;
  onConfirm: (reason: string) => void;
  onClose: () => void;
  isLoading?: boolean;
}

interface FormData {
  reason: string;
}

const DenyAccessRequestModal: React.FC<DenyAccessRequestModalProps> = ({
  requestedBy,
  onConfirm,
  onClose,
  isLoading = false,
}) => {
  const { register, handleSubmit, formState: { errors } } = useForm<FormData>();
  const formId = useId();

  const onSubmit = (data: FormData) => {
    onConfirm(data.reason);
  };

  return (
    <Modal
      open
      onClose={onClose}
      size="md"
      title="Deny Access Request"
      description={`Request by: ${requestedBy}`}
      footer={
        <>
          <Button variant="secondary" type="button" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button variant="danger" type="submit" form={formId} disabled={isLoading} loading={isLoading}>
            {isLoading ? 'Denying...' : 'Deny Request'}
          </Button>
        </>
      }
    >
      <form id={formId} onSubmit={handleSubmit(onSubmit)}>
        <Textarea
          label="Denial Reason"
          required
          {...register('reason', {
            required: 'Denial reason is required',
            minLength: { value: 10, message: 'Reason must be at least 10 characters' }
          })}
          rows={4}
          placeholder="Please provide a clear reason for denying this access request..."
          disabled={isLoading}
        />
        {errors.reason && (
          <p className="mt-1 text-sm text-[var(--danger-text)]">
            {errors.reason.message}
          </p>
        )}
      </form>
    </Modal>
  );
};

export default DenyAccessRequestModal;
